import { GET_CASESTUDY_CATEGORIES, GET_CASESTUDY_CATEGORIES_ERR } from '../../actionTypes/casestudyType'
import { getCasestudyCategoriesApi } from 'api/Api';
import axios from "axios";

export const getCasestudyCategories = payload => async dispatch => {
    try {
        console.log('payload',payload)
        let results = await axios.get(`${getCasestudyCategoriesApi}/${payload.filter}/${payload.page}`)
        console.log("GET CASESTUDY CATEGORIES", results)
        let data = results && results.data
        dispatch({
            type: GET_CASESTUDY_CATEGORIES,
            payload: data || [],
        });
    } catch (error) {
        dispatch({
            type: GET_CASESTUDY_CATEGORIES_ERR,
            payload: error && error.response
        });
    }
}

